exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trace-window[data-v-3a7d360b]{position:absolute;padding:0;top:0;right:200px;width:480px;height:125px;background:#fff;z-index:99999}.trace-input-date[data-v-3a7d360b]{width:100%}.label[data-v-3a7d360b]{font-size:12px;font-weight:700}input[type=color][data-v-3a7d360b]{-webkit-appearance:none;border:none;width:50px;height:25px}input[type=color][data-v-3a7d360b]::-webkit-color-swatch-wrapper{padding:0}input[type=color][data-v-3a7d360b]::-webkit-color-swatch{border:none}.bottom-controls[data-v-3a7d360b]{padding-top:10px}", ""]);

// exports
